module.exports = "\r\n<div class=\"d-flex align-items-center justify-content-center data-status\">\r\n    <svg class=\"loader\" viewBox=\"0 0 60 60\" xmlns=\"http://www.w3.org/2000/svg\">\r\n        <circle class=\"loader-circle\" cx=\"30\" cy=\"30\" r=\"20\" stroke=\"#70c542\" stroke-width=\"3\"></circle>\r\n    </svg>\r\n    <p class=\"mb-0\">Loading data</p>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/templates/common/spinner.component.html
// module id = 460
// module chunks = 0